// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3FeKj","gfeWrapper":"CalendarEvent_gfeWrapper__29oSm"};